(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prepareMarquee(section) {
    if (section.dataset.galleryReady === 'true') return;
    section.dataset.galleryReady = 'true';

    var marquee = section.querySelector('.index-gallery__marquee');
    var group = section.querySelector('[data-index-gallery-group]');
    if (!marquee || !group) return;
    if (reduceMotion.matches) return;

    var clone = group.cloneNode(true);
    clone.removeAttribute('data-index-gallery-group');
    clone.setAttribute('aria-hidden', 'true');

    clone.querySelectorAll('a').forEach(function (link) {
      link.setAttribute('tabindex', '-1');
    });

    clone.querySelectorAll('img').forEach(function (img) {
      img.alt = '';
      img.setAttribute('alt', '');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
      img.setAttribute('fetchpriority', 'low');
    });

    marquee.appendChild(clone);
  }

  function setInView(section, inView) {
    if (reduceMotion.matches) {
      section.classList.remove('index-gallery--in-view');
      return;
    }

    if (inView) {
      prepareMarquee(section);
      section.classList.add('index-gallery--in-view');
    } else {
      section.classList.remove('index-gallery--in-view');
    }
  }

  function bindSection(section) {
    if (section.dataset.galleryBound === 'true') return;
    section.dataset.galleryBound = 'true';

    if (!('IntersectionObserver' in window)) {
      prepareMarquee(section);
      setInView(section, true);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setInView(section, entry.isIntersecting);
        });
      },
      { rootMargin: '200px 0px', threshold: 0.01 }
    );

    observer.observe(section);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll('[data-index-gallery]')
      : [];

    if (!sections.length && scope.hasAttribute && scope.hasAttribute('data-index-gallery')) {
      sections = [scope];
    }

    for (var i = 0; i < sections.length; i += 1) {
      bindSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (typeof reduceMotion.addEventListener === 'function') {
    reduceMotion.addEventListener('change', function () {
      document.querySelectorAll('[data-index-gallery]').forEach(function (section) {
        section.dataset.galleryReady = '';
        section.dataset.galleryBound = '';
        var clone = section.querySelector('.index-gallery__group[aria-hidden="true"]');
        if (clone) clone.remove();
        bindSection(section);
      });
    });
  }
})();
